export const globalComplianceText =
  "Notice: This platform is an administrative optimization tool. All AI-generated functional assessments, financial forecasts, wholesale cost aggregations, 3D metric visualizations, and documentation templates are strictly informational. Final clinical specifications, billing submittals, prescriptions, and custom fabrication workflows require formal, independent review and explicit sign-off by a licensed physician and a Certified Prosthetist prior to patient care.";

export const hipaaConsentText =
  "HIPAA Required Authorization: You are choosing to securely share your collected personal information, smartphone 3D scan metrics, and preliminary clinical intake notes with {clinicName} to coordinate your care.";

export const postConsentConfirmation =
  "Your clinical intake profile has been securely transferred to your chosen clinic, and their staff has been notified. A clinic representative will contact you within 24 hours using your preferred form of contact to schedule your initial custom prosthetist consultation.";

export const mockPatient = {
  fullName: "Michael J. Torres",
  dateOfBirth: "1985-07-12",
  phone: "(903) 555-0187",
  email: "michael.torres@email.com",
  contactMethod: "SMS",
  amputationLevel: "Below Knee (Transtibial)",
  amputationDate: "2025-11-18",
  kLevel: "K3",
  kLevelDescription: "Community Ambulator",
  mobilityGoals: [
    "Daily Walking",
    "Return to Work",
    "Navigating Uneven Terrain",
  ],
  insuranceProvider: "Blue Cross Blue Shield",
  policyId: "BCBS-847201-TX",
  zipCode: "75701",
};

export const calendarSlot = {
  nextDate: "Today at 2:15 PM",
  duration: "20 min",
  physician: "Dr. A. Paliga, MD",
  physicianPhotoUrl:
    "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20a%20mature%20male%20doctor%20in%20his%20early%20fifties%20with%20salt%20and%20pepper%20hair%20and%20a%20short%20well%20groomed%20beard%2C%20wearing%20a%20soft%20cream%20white%20medical%20coat%20over%20a%20pale%20blue%20button%20down%20shirt%2C%20warm%20genuine%20reassuring%20smile%2C%20kind%20wise%20eyes%20with%20subtle%20laugh%20lines%2C%20soft%20natural%20daylight%20illumination%20from%20a%20window%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20cream%20and%20beige%20neutral%20background%2C%20shallow%20depth%20of%20field%2C%20professional%20healthcare%20photography%2C%20compassionate%20trustworthy%20and%20approachable%20demeanor%2C%20calm%20and%20steady%20presence&width=400&height=400&seq=physician-dr-paliga&orientation=squarish",
};

export const clinics = [
  {
    id: "clinic-1",
    name: "Tyler Prosthetics",
    distance: "1.2 mi",
    address: "1420 S Beckham Ave, Tyler, TX 75701",
    phone: "(903) 555-0234",
    rating: 4.8,
    reviewCount: 124,
    acceptingPatients: true,
    specialties: ["Below Knee", "Above Knee", "Bilateral Below Knee"],
    prosthetists: [
      {
        name: "Dr. Sarah Chen, CPO",
        title: "Lead Prosthetist",
        yearsActive: 14,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20East%20Asian%20female%20doctor%20in%20her%20forties%20wearing%20a%20soft%20cream%20colored%20medical%20coat%20over%20neutral%20clothing%2C%20warm%20genuine%20smile%2C%20kind%20eyes%2C%20soft%20natural%20daylight%20coming%20from%20a%20window%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20neutral%20background%20in%20cream%20and%20beige%20tones%2C%20shallow%20depth%20of%20field%2C%20professional%20healthcare%20photography%2C%20approachable%20and%20compassionate%20expression&width=400&height=400&seq=prosthetist-sarah-chen&orientation=squarish",
      },
      {
        name: "Marcus Williams, CP",
        title: "Certified Prosthetist",
        yearsActive: 9,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20African%20American%20male%20healthcare%20professional%20in%20his%20thirties%20wearing%20a%20soft%20gray%20medical%20scrub%20top%2C%20warm%20confident%20smile%2C%20kind%20and%20empathetic%20expression%2C%20soft%20natural%20daylight%20illumination%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20cream%20and%20beige%20background%2C%20shallow%20depth%20of%20field%2C%20professional%20clinical%20photography%2C%20approachable%20and%20reassuring%20demeanor&width=400&height=400&seq=prosthetist-marcus-williams&orientation=squarish",
      },
    ],
  },
  {
    id: "clinic-2",
    name: "East Texas Limb Restoration Clinic",
    distance: "2.7 mi",
    address: "211 E Front St, Tyler, TX 75702",
    phone: "(903) 555-0456",
    rating: 4.6,
    reviewCount: 89,
    acceptingPatients: true,
    specialties: ["Below Knee", "Upper Extremity"],
    prosthetists: [
      {
        name: "Dr. James Okonkwo, CPO",
        title: "Clinical Director",
        yearsActive: 18,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20African%20male%20doctor%20in%20his%20late%20forties%20wearing%20a%20cream%20white%20coat%20over%20a%20light%20blue%20button%20up%20shirt%2C%20warm%20genuine%20smile%20with%20crinkles%20around%20eyes%2C%20wise%20and%20kind%20expression%2C%20soft%20natural%20daylight%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20neutral%20background%20in%20cream%20and%20beige%20tones%2C%20shallow%20depth%20of%20field%2C%20professional%20healthcare%20photography%2C%20compassionate%20and%20trustworthy%20demeanor&width=400&height=400&seq=prosthetist-james-okonkwo&orientation=squarish",
      },
      {
        name: "Priya Patel, CP",
        title: "Certified Prosthetist",
        yearsActive: 7,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20South%20Asian%20Indian%20female%20healthcare%20professional%20in%20her%20thirties%20wearing%20a%20soft%20sage%20green%20medical%20scrub%20top%2C%20warm%20bright%20smile%2C%20kind%20and%20encouraging%20eyes%2C%20soft%20natural%20daylight%20illumination%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20cream%20and%20beige%20background%2C%20shallow%20depth%20of%20field%2C%20professional%20clinical%20photography%2C%20approachable%20and%20caring%20expression&width=400&height=400&seq=prosthetist-priya-patel&orientation=squarish",
      },
    ],
  },
  {
    id: "clinic-3",
    name: "Lone Star Advanced Prosthetics Group",
    distance: "4.5 mi",
    address: "680 S Broadway Ave, Tyler, TX 75701",
    phone: "(903) 555-0789",
    rating: 4.9,
    reviewCount: 203,
    acceptingPatients: true,
    specialties: [
      "Below Knee",
      "Above Knee",
      "Bilateral Below Knee",
      "Upper Extremity",
    ],
    prosthetists: [
      {
        name: "Dr. Rebecca Torres, CPO",
        title: "Chief Prosthetist",
        yearsActive: 16,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20Hispanic%20Latina%20female%20doctor%20in%20her%20forties%20wearing%20a%20soft%20cream%20white%20medical%20coat%20over%20a%20warm%20toned%20blouse%2C%20warm%20confident%20smile%2C%20kind%20and%20empathetic%20expression%2C%20soft%20natural%20daylight%20coming%20from%20a%20window%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20neutral%20background%20in%20cream%20and%20beige%20tones%2C%20shallow%20depth%20of%20field%2C%20professional%20healthcare%20photography%2C%20approachable%20and%20compassionate%20demeanor&width=400&height=400&seq=prosthetist-rebecca-torres&orientation=squarish",
      },
      {
        name: "Daniel Kim, CP",
        title: "Certified Prosthetist",
        yearsActive: 11,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20East%20Asian%20Korean%20male%20healthcare%20professional%20in%20his%20thirties%20wearing%20a%20soft%20heather%20gray%20medical%20scrub%20top%2C%20warm%20calm%20smile%2C%20kind%20and%20patient%20expression%2C%20soft%20natural%20daylight%20illumination%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20cream%20and%20beige%20background%2C%20shallow%20depth%20of%20field%2C%20professional%20clinical%20photography%2C%20reassuring%20and%20approachable%20demeanor&width=400&height=400&seq=prosthetist-daniel-kim&orientation=squarish",
      },
      {
        name: "Angela Foster, CP",
        title: "Certified Prosthetist",
        yearsActive: 6,
        photoUrl:
          "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20Caucasian%20female%20healthcare%20professional%20in%20her%20early%20thirties%20wearing%20a%20soft%20dusty%20rose%20medical%20scrub%20top%2C%20warm%20friendly%20smile%2C%20kind%20and%20encouraging%20eyes%2C%20soft%20natural%20daylight%20illumination%2C%20head%20and%20shoulders%20portrait%2C%20simple%20warm%20cream%20and%20beige%20background%2C%20shallow%20depth%20of%20field%2C%20professional%20clinical%20photography%2C%20approachable%20and%20caring%20expression&width=400&height=400&seq=prosthetist-angela-foster&orientation=squarish",
      },
    ],
  },
];

export const amputationSpecialtyTags: Record<string, string> = {
  "below-knee": "Transtibial Specialist Available",
  "above-knee": "AKA Specialist Available",
  "bilateral-bk": "Bilateral Specialist Available",
  "upper-extremity": "Upper Extremity Specialist Available",
  other: "Complex Case Specialist Available",
};

export const artifactCards = [
  {
    id: "clinical-notes",
    title: "Clinical Intake Notes & Functional Mobility Assessment",
    icon: "ri-file-text-line",
    accentClass: "bg-primary-100 text-primary-800",
    badgeText: "H&P Template",
    sections: [
      { label: "Patient", value: "Michael J. Torres" },
      { label: "DOB", value: "July 12, 1985 (Age 40)" },
      {
        label: "Chief Concern",
        value:
          "Right transtibial amputation — seeking definitive prosthetic fitting",
      },
      { label: "Amputation Date", value: "November 18, 2025" },
      {
        label: "Amputation Level",
        value: "Below Knee (Transtibial) — Right side",
      },
      {
        label: "Mobility Goals",
        value: "Daily walking, return to work, navigating uneven terrain",
      },
      { label: "Insurance", value: "Blue Cross Blue Shield — BCBS-847201-TX" },
      { label: "K-Level Target", value: "K3 (Community Ambulator)" },
      { label: "Comorbidities", value: "None reported — cleared for fitting" },
    ],
  },
  {
    id: "prosthetic-prescription",
    title: "Prosthetic Prescription Template",
    icon: "ri-file-list-3-line",
    accentClass: "bg-accent-100 text-accent-800",
    badgeText: "Pre-Populated",
    sections: [
      { label: "Device Code", value: "L-5980 — Preparatory BK Prosthesis" },
      {
        label: "Socket Design",
        value: "Total Surface Bearing (TSB) with distal cup",
      },
      {
        label: "Suspension System",
        value: "Pin-Lock with silicone liner interface",
      },
      {
        label: "Foot Component",
        value: "Energy Storing Dynamic Response Foot",
      },
      {
        label: "K-Level",
        value: "K3 — Community Ambulation with variable cadence",
      },
      { label: "Duration of Need", value: "Lifetime" },
      {
        label: "Diagnosis",
        value: "Acquired transtibial amputation — post-traumatic",
      },
      { label: "Physician", value: "Dr. A. Paliga, MD (Pending Sign-Off)" },
    ],
  },
  {
    id: "work-order",
    title: "Standard Work Order",
    icon: "ri-clipboard-line",
    accentClass: "bg-secondary-100 text-secondary-800",
    badgeText: "Fabrication Template",
    sections: [
      {
        label: "Day 1",
        value: "Diagnostic cast capture & residual limb digital scan",
      },
      {
        label: "Day 2-3",
        value: "Diagnostic socket fabrication & bench alignment",
      },
      {
        label: "Day 4",
        value: "Initial fitting session — static & dynamic alignment",
      },
      {
        label: "Day 5-7",
        value: "Definitive socket lamination with carbon fiber weave",
      },
      {
        label: "Day 8-10",
        value: "Dynamic alignment refinement & gait training sessions",
      },
      {
        label: "Day 11",
        value: "Final delivery — patient education & outcome assessment",
      },
    ],
  },
];

export const financialROI = {
  insuranceReimbursement: 8200,
  wholesaleMaterialsCost: 1450,
  dataLeaseFee: 500,
  totalEstimatedCost: 1950,
  netMarginPercent: 76.2,
  netProfit: 6250,
  lCodes: ["L-5980", "L-5781", "L-5637", "L-5973", "L-5960", "L-5620"],
  lCodeBreakdown: [
    {
      code: "L-5980",
      description: "Preparatory Below Knee Prosthesis — Base Code",
      category: "Socket & Interface",
      allowable: 2800,
      units: 1,
      notes: "Medicare PDAC verified — allowable for K3",
    },
    {
      code: "L-5781",
      description: "Addition — Vacuum Pump Residual Limb Volume Management",
      category: "Suspension",
      allowable: 1200,
      units: 1,
      notes: "Medical necessity met — documented volume fluctuation",
    },
    {
      code: "L-5637",
      description: "Addition — Total Surface Bearing (TSB) Socket",
      category: "Socket & Interface",
      allowable: 900,
      units: 1,
      notes: "TSB clinically indicated per eval notes",
    },
    {
      code: "L-5973",
      description: "Endoskeletal System — Prosthetic Foot & Ankle Assembly",
      category: "Structural Components",
      allowable: 1500,
      units: 1,
      notes: "Energy-storing dynamic response foot approved",
    },
    {
      code: "L-5960",
      description: "Endoskeletal System — Below Knee, Ultralight Materials",
      category: "Structural Components",
      allowable: 1300,
      units: 1,
      notes: "Carbon fiber pylon — lightweight construction approved",
    },
    {
      code: "L-5620",
      description: "Addition — Test Socket, Below Knee",
      category: "Fitting & Evaluation",
      allowable: 500,
      units: 1,
      notes: "Diagnostic fitting socket prior to definitive delivery",
    },
  ],
  insuranceCoverage: {
    provider: "Blue Cross Blue Shield",
    planType: "PPO — Texas Market",
    policyStatus: "Verified Active",
    verificationDate: "June 11, 2026",
    preAuthorizationRef: "BCBS-PA-2026-44392",
    preAuthStatus: "Pending — Awaiting Prosthetist Evaluation",
    coveragePercent: 80,
    patientResponsibilityPercent: 20,
    annualDeductible: 1500,
    deductibleRemaining: 750,
    outOfPocketMax: 4500,
    outOfPocketRemaining: 3200,
    coveredServices: [
      "Prosthetic devices (preparatory & definitive)",
      "Socket fabrication & componentry",
      "Fitting, alignment & gait training sessions",
      "Replacement due to normal wear or physiological change",
    ],
    notes:
      "Prior authorization obtained for all six L-Codes. No concurrent Medicare coverage — commercial primary. Policy effective 01/01/2026. Prosthetic benefit: 80% of allowable after deductible, no visit limits, no calendar cap on durable medical equipment.",
  },
  lineItems: [
    {
      label: "Wholesale Materials Cost",
      value: 1450,
      detail:
        "Carbon fiber socket, dynamic foot module, pylon, suspension sleeve, interface liner, cosmetic cover",
    },
    {
      label: "Quick Prosthetics Data Lease Fee",
      value: 500,
      detail:
        "AI-generated patient file, 3D limb metrics, clinical artifact suite, sourcing forecast",
      highlighted: true,
    },
    {
      label: "Total Estimated Cost",
      value: 1950,
      detail:
        "Aggregated across contracted vendor catalogs. Includes all components, data licensing, and fabrication inputs.",
      highlighted: false,
      isTotal: true,
    },
  ],
};

export const clinicRecipient = {
  name: "Tyler Prosthetics",
  address: "1420 S Beckham Ave, Tyler, TX 75701",
  phone: "(903) 555-0234",
  leadProsthetist: "James McPherson, CP",
};

export const processedItems = [
  {
    label: "Complete Patient Intake",
    detail:
      "Demographics, medical history, mobility goals, functional indicators",
  },
  {
    label: "Physician Medical Evaluation",
    detail: "Dr. A. Paliga, MD — telehealth consult completed and signed off",
  },
  {
    label: "3D Lower Limb Scan",
    detail: "MyFit smartphone photogrammetry — residual limb geometry captured",
  },
  {
    label: "Residual Limb Photography",
    detail: "High-resolution multi-angle clinical imaging processed",
  },
  {
    label: "Complete PHI Package",
    detail:
      "Full protected health information and insurance verification — BCBS-847201-TX verified active",
    blurred: true,
  },
  {
    label: "Suggested Standard Work Order",
    detail:
      "AI-generated SWO with component modifiers mapped to K3 functional level",
  },
];
